// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"46dc3e92","551":"03bced4b","842":"ca086022"}[chunkId] + ".chunk.js";
};